import { School } from "../interfaes/school";
import { Student } from "../interfaes/student";
import axios from "axios";

export async function onAddNewSchool(school: School) {

    return await axios.post(
        '/schools',
        school
    );

}
export async function onUpdateSchool(school: School, id: string) {

    return await axios.put(
        `/schools/${id}`,
        {
            'school': school
        }
    );

}

export async function onGetSchools() {
    return await axios.get(
        '/schools/allSchools'
    );
}

export async function onGetSchoolById(id: string) {
    return await axios.get<School>(`/schools/${id}`);
}

export async function onDeleteSchools(id: String) {
    return await axios.delete(
        `/schools/${id}`
    );
}

export async function onGetStudentsBySchool(schoolId: string) {
    return await axios.get<Student[]>(`/schools/${schoolId}/students`);
}

export async function onGetStudentCountsBySchool() {
    const res = await axios.get<Record<string, number>>("/schools/student-counts");
    return res.data ?? {};
}